<template>
    <div class="mid-container login-page">
        <div class="left-side">
            <div class="fill">
            </div>
        </div>
        <div class="right-side">
            <div class="fill">
            </div>
        </div>
        <div class="mid-side">
            <div class="block-wrapper auth-block-wrapper">
                <h1 class="auth-block-header">{{$t('login.REGISTER_FORM_WELCOME')}}</h1>
                <span class="auth-block-text"></span>
                <div class="form-wrapper">
                    <div class="form-field">
                        <label>{{$t('login.REGISTER_FORM_EMAIL_LABEL')}}<span class="required">*</span></label>
                        <div class="input-wrapper">
                            <input v-model="form.email" :placeholder="$t('login.REGISTER_FORM_EMAIL_PLACEHOLDER')" />
                        </div>
                    </div>
                    <div class="form-field">
                        <label>{{$t('login.REGISTER_FORM_PHONE_LABEL')}}<span class="required">*</span></label>
                        <div class="input-wrapper">
                            <input v-model="form.phone" :placeholder="$t('login.REGISTER_FORM_PHONE_PLACEHOLDER')" />
                        </div>
                    </div>

                    <transition name="component-fade-route" mode="out-in">
                        <p v-html="form.error" class="form-error"></p>
                    </transition>

                    <button class="button disabled" v-if="!validated">
                        {{$t('login.REGISTER_FORM_PRIMARY_BUTTON_LABEL')}}
                    </button>
                    <button v-else class="button" @click="register">
                        <LoadingIndicator
                            v-if="loading"
                            style="position: absolute; right: 17px; width: 2rem; height: 2rem"
                            class="white"
                        />
                        {{$t('login.REGISTER_FORM_PRIMARY_BUTTON_LABEL')}}
                    </button>

                    <div class="support-button" @click="VerboxSupportOpen">
                        <div class="icon icon-help-circle"></div>
                        <span>{{$t('strings.TECHNICAL_SUPPORT')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CheckBox from '@/components/checkbox/CheckBox.vue'
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import ErrorPopup from '@/views/pages/manager_popups/ErrorPopup';
    import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';

    export default {
        name: 'RegistrationPage',
        components: {
            LoadingIndicator
        },
        data:function(){
            return {
                loading:false,
                form:{
                    first_name:this.$route.query.first_name||"",
                    last_name:this.$route.query.last_name||"",
                    email:this.$route.query.email||"",
                    password:"",
                    birthday:this.$route.query.birthday||"",
                    phone:this.$route.query.phone||"",
                    error:"",
                }
            }
        },
        mounted(){
        },
        methods: {
            register(){
                this.form.error = "";
                this.loading = true;
                rest.call("update_fb_profile",{
                    "session":typeof this.$route.query.token != 'undefined'?this.$route.query.token:"",
                    "data":{
                        "email":this.form.email,
                        "password":this.form.password,
                        "phone":this.form.phone,
                        "first_name":this.form.first_name,
                        "last_name":this.form.last_name,
                        "birthday":this.form.birthday,
                    },
                    "language":i18n.locale,
                },"POST",false).then((response)=>{
                    if(response.id){
                        this.loading = false;
                        //Авторизируемся с помощью лида
                        window.location.href = (window.location.origin+"/"+i18n.locale+"/social_login?provider=&token="+response.id);
                        return;
                    }else{
                        this.loading = false;
                        if(response.number){
                            this.form.error = i18n.t("soap."+response.number);
                        }else if(typeof response.description != "undefined"){
                            this.form.error = response.description;
                        }
                    }
                }).catch((error)=>{
                    this.loading = false;
                    
                });
            },
            /**
             * Открывает окно чата
             */
            VerboxSupportOpen(){
                Verbox("openSupport");
            },
            /**
             * Открывает окно отзывов
             */
            VerboxFeedBackOpen(){
                Verbox("openReviewsTab");
            },
        },
        computed:{
            validated(){
                if(!this.form.email || this.form.email.toString().trim().length==0 || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.form.email)==false) return false;
                if(!this.form.phone || this.form.phone.toString().trim().length<6) return false;
                return true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .support-button{
        background: #FFFFFF;
        border-radius: 50px;
        padding: 16px 32px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        color: rgba(11,16,34,.3);
        margin-top: 50px;
        &>.icon{
            width: 32px;
            height: 32px;
            font-size: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;
        }
        &>span{
            font-family: FuturaPT;
            font-size: 21px;
            line-height: 16px;
            letter-spacing: .5px;
        }
        &:hover{
            color:#cf0920;
        }
    }
    .form-wrapper{
        display: flex;
        flex-direction: column;
        font-size: 1.6rem;
        width: 30rem;
        margin-bottom: 0.5rem;
        margin-top: 30px;
        input {
            width: 100%;
            margin-bottom: 1rem;

            background: #FFFFFF;
            border-radius: 24rem;
            font-family: Futura;
            font-style: normal;
            font-weight: 500;
            border: 0;
            outline: none;
            color: rgba(11, 16, 34, 0.3);
            font-size: 21px;
            line-height: 63px;
            padding: 0px 30px;
        }
        button {
            padding: 18px 32px;
            position: relative;
        }
        .form-error {
            padding-top: 10rem;    
            color: #f44336;
            margin-bottom: 15px;
        }
        .form-field{
            width: 100%;
            margin-bottom: 10px;
            &>label{
                font-family: 'FuturaPT';
                font-size: 20px;
                .required{
                    color:#f44336;
                }
            }
            .input-wrapper{
                margin-top:5px;
                input{
                    font-family: 'FuturaPT';
                    color: #263238;
                    &::placeholder{
                        color:#b5b7bc;
                    }
                }
            }
        }
    }
    .mid-container{
        min-height: 100vh;
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .left-side,.right-side{
            width:50%;
            flex:1;
        }
        .right-side .fill{
            left:50%;
        }
        .mid-side{
            position: absolute;    
            background: #F2F2F2;
            min-height: 100vh;
        }
    }
    .login-page{
        .fill{
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            width: 50%;
            background-image: url("../../../assets/login/left_side.jpg");
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        .logo-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;

            .logo {
                display: flex;    
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: default;

                img {
                    width: 200px;
                    height:auto;
                    padding-bottom: 2rem;
                }

                span {
                    font-family: FuturaPT;
                    font-size: 3.75rem;
                    line-height: 4rem;
                    letter-spacing: 1px;
                    color: #FFFFFF;
                }
            }
        }
        .auth-block-wrapper {
            padding: 90px;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            .auth-block {
                display: flex;
                flex-direction: column;

                .auth-block-header {
                    font-family: FuturaPT;
                    font-size: 3.2rem;
                    line-height: 4rem;
                    letter-spacing: 1px;
                    color: #0B1022;
                    margin: 0;
                }

                .auth-block-text {
                    font-family: FuturaPT;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 1.6rem;
                    line-height: 2.1rem;
                    letter-spacing: 0.5px;
                    color: rgba(11, 16, 34, 0.3);
                    padding-bottom: 2rem;
                }

                .is-save-auth-wrapper {
                    display: flex;
                    align-items: center;
                    padding-top: 2.0rem;
                    padding-left: 1.5rem;

                    span {
                        font-family: FuturaPT;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 1.6rem;
                        line-height: 2.1rem;
                        text-align: center;
                        letter-spacing: 0.5px;
                        color: rgba(11, 16, 34, 0.3);
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
    .button{
        &.disabled{
            cursor: default;
            background: #d7dade;
            color: #8c909c;
        }
    }
    @media(max-width:540px){
        .mid-container .mid-side{
            max-width: 100%;
            left:30px;
            right:30px;
            .auth-block-wrapper{
                padding:30px;
            }
            .form-wrapper{
                width: 100%;
            }
        }
    }
</style>